import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { store } from 'redux-rest-reducer';
import { get as getConfig } from 'actions/configs';
import { getCookie } from 'utils';
import { AV_REVIEW_CONFIG, AV_REVIEW_ROLES } from 'constants/av-review';

const useAVReviewRole = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getConfig?.(AV_REVIEW_CONFIG));
  }, [dispatch]);

  const configData = useSelector(({ configs }) => store.get(configs, AV_REVIEW_CONFIG));
  const { admin_ids = [] } = configData?.data ?? {};
  const reviewers = useMemo(() => configData?.data?.reviewers || [], [configData]);
  const reviewerIds = useMemo(() => reviewers.map(r => r.id), [reviewers]);
  const isLoading = configData?.isLoading || !configData?.data;

  const authId = useSelector(({ auth }) => auth?.user_id);
  const userId = useMemo(() => authId || getCookie('emp_id') || getCookie('user_id'), [
    authId,
  ]);

  const role = useMemo(() => {
    if (!userId || !configData?.data) return null;
    if (admin_ids.includes(userId)) return AV_REVIEW_ROLES.ADMIN;
    if (reviewerIds.includes(userId)) return AV_REVIEW_ROLES.REVIEWER;
    return null;
  }, [userId, configData?.data, admin_ids, reviewerIds]);

  return { role, userId, isLoading, reviewers };
};

export default useAVReviewRole;
